'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunicationMethodsPrompt = undefined;

var _Promptable = require('UIComponents/decorators/Promptable');

var _Promptable2 = _interopRequireDefault(_Promptable);

var _CommunicationMethodsModal = require('ui-addon-upgrades/_core/communicationMethods/CommunicationMethodsModal');

var _CommunicationMethodsModal2 = _interopRequireDefault(_CommunicationMethodsModal);

var _PromiseHandlers = require('UIComponents/core/PromiseHandlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationMethodsPrompt = exports.CommunicationMethodsPrompt = function CommunicationMethodsPrompt(propsToPass) {
  var _prompt = (0, _Promptable2.default)(_CommunicationMethodsModal2.default);

  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/CommunicationMethodsPrompt.js
// module id = 551
// module chunks = 3 4 5